import { singleton } from 'tsyringe';

import { CookieKey, getCookie, setCookie } from '@/infra/cookie';
import { ConfigRepository, ThemeType } from '@/v1/main/domain/config';

@singleton()
export class ConfigRepositoryImpl implements ConfigRepository {
    public constructor() {
        console.log('new config repository');
    }

    public getTheme(): ThemeType {
        return (getCookie(CookieKey.THEME) as ThemeType) || ThemeType.LIGHT;
    }
    public setTheme(value: ThemeType): void {
        return setCookie(CookieKey.THEME, value);
    }
}
